import React from "react";
import { Link } from "react-router-dom";
import "./SiteFooter.css";

const YEAR = new Date().getFullYear();

/** Site-wide Vista footer: wordmark + tagline, navigation columns, fine print. */
export default function SiteFooter() {
  return (
    <footer className="v-foot">
      <div className="v-foot__grid">
        <div className="v-foot__brand-col">
          <div className="v-foot__brand v-display">
            nature<span>4d</span>
          </div>
          <p className="v-foot__tagline">
            Fine-art landscape &amp; nature photography — glaciers, wildlife, and
            wild light gathered from the field around the world.
          </p>
        </div>

        <nav className="v-foot__col" aria-label="Explore">
          <h4 className="v-foot__heading">Explore</h4>
          <Link className="v-foot__link" to="/">
            Home
          </Link>
          <Link className="v-foot__link" to="/portfolio">
            Portfolio
          </Link>
          <Link className="v-foot__link" to="/collections">
            Collections
          </Link>
          <Link className="v-foot__link" to="/locations">
            Locations
          </Link>
        </nav>

        <nav className="v-foot__col" aria-label="Studio">
          <h4 className="v-foot__heading">Studio</h4>
          <Link className="v-foot__link" to="/about">
            About
          </Link>
          <a className="v-foot__link" href="mailto:studio@nature4d.com">
            Commissions
          </a>
          <a className="v-foot__link" href="mailto:studio@nature4d.com">
            Contact
          </a>
        </nav>
      </div>

      <div className="v-foot__note">
        <span>© {YEAR} nature4d — all rights reserved</span>
        <span>studio@nature4d.com</span>
      </div>
    </footer>
  );
}
